export default __webpack_public_path__ + "static/media/Butterfly.cabd2814.png";